import { useQuery } from "react-query";

import http from "../../../services/httpService";
import Util from "../../../util/util";
import useUrls from "../../useUrls";

/**
 * @param {string} apiUrl
 * @returns {function(): Promise<*>}
 */
const getDomains = (apiUrl) => async () => {
  console.log("getDomains() called...");

  const config = Util.addTokenToHeaders();
  const { data } = await http.get(`${apiUrl}/admin/remote/domains`, config);

  console.log("getDomains() response data:");
  console.log(data);

  return data;
};

export default function useQueryRemoteDomains() {
  const { apiUrl } = useUrls();

  return useQuery(["admin", "remote", "domains"], getDomains(apiUrl), {
    enabled: !!localStorage.getItem("token"),
  });
}
